module.exports = __webpack_public_path__ + "img/bmyd1.fa382428.png";